import { Psychologist } from "utils/interfaces"

export const getAvailableLocations = (psy: Psychologist, reverse?: boolean) => {
    const availableLocations = []
    if (psy.offered_services.some((service) => !service.online)) {
        availableLocations.push("лично")
    }
    if (psy.offered_services.some((service) => service.online)) {
        availableLocations.push("онлайн")
    }

    if (reverse) {
        availableLocations.reverse()
    }

    return availableLocations.join(" и ")
}
